import { render, staticRenderFns } from "./DormUserStatistic.vue?vue&type=template&id=943d7e20&"
import script from "./DormUserStatistic.vue?vue&type=script&lang=js&"
export * from "./DormUserStatistic.vue?vue&type=script&lang=js&"
import style0 from "./DormUserStatistic.vue?vue&type=style&index=0&id=943d7e20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports